import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GlobalVariable} from '../../../global';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-operation-identity',
  templateUrl: './operation-identity.component.html',
  styleUrls: ['./operation-identity.component.scss']
})
export class OperationIdentityComponent implements OnInit {
  idTypes: string[] = GlobalVariable.CUSTOMER_ID_TYPES;
  /** Date minimale sélectionnable : début du jour courant (pas de date passée). */
  minCardExpirationDate: Date;
  @Input('operationIdTypeFormControl') operationIdTypeFormControl: FormControl;
  @Input('operationIdNumberFormControl') operationIdNumberFormControl: FormControl;
  @Input('operationCardExpirationFormControl') operationCardExpirationFormControl: FormControl;
  @Input('idTypePlaceholder') idTypePlaceholder: string;
  @Input('idNumberPlaceholder') idNumberPlaceholder: string;
  @Output() onOperationIdTypeSelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() onOperationIdNumberBlur: EventEmitter<string> = new EventEmitter<string>();
  @Output() onOperationCardExpirationBlur: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }
  ngOnInit() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    this.minCardExpirationDate = d;
   // this.operationIdNumberFormControl.disable();
  }
  onIdTypeSelection(e) {
    if (this.operationIdNumberFormControl.value === null || this.operationIdNumberFormControl.value === '') {
       this.operationIdNumberFormControl.enable();
       this.operationIdNumberFormControl.markAsTouched({onlySelf: true});
       this.operationIdNumberFormControl.setErrors({required: true});

       this.operationCardExpirationFormControl.enable();
      this.operationCardExpirationFormControl.markAsTouched({onlySelf: true});
      this.operationCardExpirationFormControl.setErrors({required: true});

    }
    if (e.value === 'NONE' || e.value === 'Aucun') {
      this.onOperationIdNumberBlur.emit(null);
      this.onOperationCardExpirationBlur.emit(null);


      this.onOperationIdTypeSelected.emit(null);

      this.operationIdNumberFormControl.disable();
      this.operationIdNumberFormControl.setErrors(null);

      this.operationCardExpirationFormControl.disable();
      this.operationCardExpirationFormControl.setErrors(null);

    } else {
      this.onOperationIdTypeSelected.emit(e.value);
    }
  }
  onIdNumberChange(e) {
    if (e.target.value) {
      this.operationIdNumberFormControl.setErrors(null);
    } else if ((e.target.value === '' || e.target.value === null) && this.operationIdTypeFormControl.value) {
      this.operationIdNumberFormControl.setErrors({required: true});
    }
  }
  onIdNumberBlur(e) {
    if (e.target.value) {
      this.onOperationIdNumberBlur.emit(e.target.value);
    }
  }

  onCardExpirationChange(e) {
    if (e.target.value) {
      this.operationCardExpirationFormControl.setErrors(null);
    } else if ((e.target.value === '' || e.target.value === null) && 
    this.operationIdTypeFormControl.value) {
      this.operationCardExpirationFormControl.setErrors({required: true});
    }
  }

  onCardExpirationBlur(e) {
    if (e.target.value) {
      this.onOperationCardExpirationBlur.emit(e.target.value);
    }
  }
  
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/operation-identity/operation-identity.component.ts